import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';
import { OutcomeLabelOptionsTypeSchema } from '@kambi/betting-client-helpers';

import classes from '../../App.module.css';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import TabsBlock from 'components/layout/tabs-block/TabsBlock';
import TestBlock from 'components/layout/test-block/TestBlock';
import Description from 'components/outcome-label/description/Description';
import { UtilsTypes } from 'constants/utilsTypes';

const OutcomeLabel = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Outcome label</div>
                <div className={classes.Main}>
                    <Description />
                    <Divider />
                    <CodeBlock
                        title="General input for the outcomeLabel method"
                        initialDisplayedCode={`{
                "outcomeId": 3139628690,
                "selections": {},
                "enableHandicapPickem": false,
                "betOffer": {
                    "id": 127, `}
                        moreCode={`"betOfferType": {
                        "id": 127,
                        "name": "Player Occurrence Line"
                    },
					"place": false,
                    "outcomes": [
                        {
                            "id": 3139628690,
                            "label": "Over",
                            "line": 500,
                            "participant": "Alonso, Pete",
                            "type": "OT_OVER"
                        },
                        {
                            "id": 3139678934,
                            "label": "Under",
                            "line": 500,
                            "participant": "Alonso, Pete",
                            "type": "OT_UNDER"
                        }
                    ]
                },
                "event": {
                        "homeName": "Washington Nationals",
                        "awayName": "New York Mets"
                    }
            }`}
                    />
                    <TabsBlock
                        title="Examples: Type of outcome labels that can be returned based on
                the betOffer"
                        type={UtilsTypes.OUTCOME_LABEL}
                    />
                    <TestBlock
                        validationSchema={OutcomeLabelOptionsTypeSchema}
                        title="You can test the outcomeLabel() method by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                        type={UtilsTypes.OUTCOME_LABEL}
                    />
                </div>
            </div>
        </div>
    );
};

export default OutcomeLabel;
